module.exports = __webpack_public_path__ + "img/img47.d8885a15.png";